import React from 'react'
import { Circles } from 'react-loader-spinner'

export default function Spinner(props) {
  return (
    <div className="spinnerWrapper" style={{ ...props.customStyle }}>
      <div className="is-flex is-justify-content-center">
        <Circles color="#00BFFF" height={40} width={40} />
      </div>
      <p>{props.note}</p>
    </div>
  )
}
